import { MENTOR_DATA_FETCHED } from "../actions/loggedInMentorData";

export default (state = null, action = {}) => {
  switch (action.type) {
    case MENTOR_DATA_FETCHED:
      return { companyId: action.payload };
    default:
      return state;
  }
};
